import { BookOpen, Lightbulb, Star, ArrowRight, ArrowLeft } from "lucide-react";

export default function TheoryView({ theory, onStartQuiz, onBack }) {
  if (!theory) return null;
  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-8 sm:py-12 ss-fadein" data-testid="theory-view">
      <button
        onClick={onBack}
        data-testid="theory-back-button"
        className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-6"
      >
        <ArrowLeft className="w-4 h-4" /> Nowy temat
      </button>

      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">
        <BookOpen className="w-3.5 h-3.5" /> Teoria
      </div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
        {theory.topic}
      </h1>

      {/* W skrócie */}
      <section className="mt-8 bg-[#FEF9C3] border border-yellow-200 rounded-3xl p-5 sm:p-6" data-testid="theory-section-summary">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-700 mb-2">
          <Star className="w-3.5 h-3.5" /> W skrócie
        </div>
        <p className="text-slate-900 text-base sm:text-lg leading-relaxed">{theory.short_summary}</p>
      </section>

      {/* Kluczowe pojęcia */}
      {theory.key_concepts?.length > 0 && (
        <section className="mt-8" data-testid="theory-section-concepts">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Najważniejsze pojęcia</h2>
          <div className="mt-4 grid sm:grid-cols-2 gap-3">
            {theory.key_concepts.map((c, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-2xl p-4 hover:border-slate-900 transition-colors">
                <div className="text-sm font-bold text-slate-900">{c.term}</div>
                <div className="mt-1 text-sm text-slate-600 leading-relaxed">{c.definition}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Sekcje */}
      {theory.sections?.map((s, i) => (
        <section key={i} className="mt-8" data-testid={`theory-section-${i}`}>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-xl bg-slate-900 text-white text-sm font-bold flex items-center justify-center">
              {i + 1}
            </div>
            <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-slate-900">{s.heading}</h2>
          </div>
          <p className="text-slate-700 text-base sm:text-lg leading-relaxed">{s.content}</p>
        </section>
      ))}

      {/* Przykłady */}
      {theory.examples?.length > 0 && (
        <section className="mt-10" data-testid="theory-section-examples">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Przykłady z życia</h2>
          <div className="mt-4 space-y-3">
            {theory.examples.map((ex, i) => (
              <div key={i} className="flex gap-3 bg-slate-50 rounded-2xl p-4">
                <div className="text-yellow-500 flex-shrink-0"><Lightbulb className="w-5 h-5" /></div>
                <p className="text-slate-700 leading-relaxed">{ex}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Zapamiętaj */}
      {theory.remember?.length > 0 && (
        <section className="mt-10 bg-white border-l-4 border-[#FFD600] rounded-r-2xl px-5 py-5 sm:px-6 sm:py-6 shadow-[0_4px_20px_-2px_rgba(15,23,42,0.05)]" data-testid="theory-section-remember">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Zapamiętaj!</div>
          <ul className="space-y-2">
            {theory.remember.map((r, i) => (
              <li key={i} className="flex gap-3 items-start">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FFD600] flex-shrink-0" />
                <span className="text-slate-900 leading-relaxed">{r}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      <div className="mt-10 sm:mt-12 sticky bottom-4 sm:static">
        <button
          onClick={onStartQuiz}
          data-testid="check-knowledge-button"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#FFD600] hover:bg-[#E6C200] text-slate-900 font-bold text-lg px-8 py-4 rounded-2xl btn-yellow-glow"
        >
          Sprawdź swoją wiedzę
          <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
